import { createTheme } from "@mantine/core";

export const theme = createTheme({
    // fontFamily: "serif",
    // ... other theme override properties
});
